/**
 * Department Theme Utility
 *
 * Pure function for determining department theme outside of React components.
 * Useful for PDF generation, server-side logic, etc.
 */

export type DepartmentId = 'default' | 'ayurveda';

export interface DepartmentTheme {
  department: DepartmentId;
  themeClass: string;
  appName: string;
  isAyurveda: boolean;
}

interface UserLike {
  practitionerRole?: {
    department?: string;
    specialty?: string;
  } | null;
  specialization?: string;
}

/**
 * Determines the department theme for a given user.
 * Returns theme metadata including CSS class and branding.
 */
export function getDepartmentTheme(user: UserLike | null | undefined): DepartmentTheme {
  if (!user) {
    return { department: 'default', themeClass: '', appName: 'Pranik.AI', isAyurveda: false };
  }

  const dept = user.practitionerRole?.department?.toLowerCase() ?? '';
  const specialty = user.practitionerRole?.specialty?.toLowerCase() ?? '';
  const specialization = user.specialization?.toLowerCase() ?? '';

  const isAyurveda =
    dept.includes('ayurveda') ||
    specialty.includes('ayurveda') ||
    specialization.includes('ayurveda');

  if (isAyurveda) {
    return {
      department: 'ayurveda',
      themeClass: 'theme-ayurveda',
      appName: 'Pranik Ayurveda',
      isAyurveda: true,
    };
  }

  return { department: 'default', themeClass: '', appName: 'Pranik.AI', isAyurveda: false };
}
